export default __webpack_public_path__ + "static/media/money-changer-banner.41c276d5.png";